// import { Routes,Route } from "react-router-dom";
import RoutePages from "../Routes/index";

const LayoutPages = () => {
  return (
    <>
      <RoutePages />
    </>
  );
};

export default LayoutPages;
